import { defineMessages } from 'react-intl';

export default defineMessages({
  showUpdatedCommits: {
    id: 'frontbucket.commitsList.updatedCommitsFlag.showUpdatedCommits',
    description:
      'This button updates the content of commits list with new/updated content',
    defaultMessage: 'Load updates',
  },
  title: {
    id: 'frontbucket.commitsList.updatedCommitsFlag.title',
    description: 'Updated commits list flag title',
    defaultMessage: 'The commits list was updated',
  },
});
